import { SxProps, Theme } from "@mui/material";

export const mainBox: SxProps<Theme> = {
  mt: 2,
  mx: 2,
  p: 1,
  bgcolor: "white",
  borderRadius: 1,
  border: "1px solid #e1e1e1",
};

export const dialogWrapper: SxProps<Theme> = {
  "& .MuiBackdrop-root": {
    backdropFilter: "blur(6px)",
    backgroundColor: "rgba(0,0,0,0.2)",
  },
};

export const sectionPaper: SxProps<Theme> = {
  border: "1px solid #e0e0e0",
  borderRadius: 2,
  p: 2,
  backgroundColor: "#ffffff",
  "&:hover": {
    borderColor: "#bdbdbd",
  },
};

export const imageScrollBox: SxProps<Theme> = {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  overflowX: "auto",
  overflowY: "hidden",
  // bgcolor: "red",
  gap: 1,
  py: 10,
  maxHeight: 150,
  boxSizing: "border-box",
  width: "100%",
  "&::-webkit-scrollbar": {
    height: "6px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "3px",
    "&:hover": {
      background: "#555",
    },
  },
  scrollbarWidth: "thin",
  scrollbarColor: "#888 #f1f1f1",
};

export const imageWrapper: SxProps<Theme> = {
  flexShrink: 0,
  position: "relative",
  width: 140,
  height: 140,
  borderRadius: 2,
  border: "1px solid #e1e1e1",
  overflow: "hidden",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const removeImageButton: SxProps<Theme> = {
  position: "absolute",
  top: 4,
  right: 4,
  backgroundColor: "rgba(0,0,0,0.5)",
  color: "#fff",
  "&:hover": {
    backgroundColor: "rgba(0,0,0,0.7)",
  },
};

export const depotBox: SxProps<Theme> = {
  border: "1px solid #ccc",
  p: 2,
  mb: 2,
  borderRadius: 1,
};

export const addPhotoBtn: SxProps<Theme> = {
  height: 140,
  width: 140,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: 1,
};
